<template>
    <vx-card>
    </vx-card>
</template>


<script>

/* eslint-disable */
import Select from './components/extra-components/select/Select.vue';
import DatepickerBornDate from './components/extra-components/datepicker/DatepikcerBornDate.vue'

import VxCard from '../components/vx-card/VxCard.vue';
import VxInputGroup from '../components/vx-input-group/VxInputGroup.vue';
import FormsRepository from './forms/e-prevision-forms/forms-repository.vue';
/* eslint-disable */

export default {
	data () {
		return {
            dni: this.$route.params.nif,
            phone: this.$route.params.phone,
            url: null,
            // username: "s.oltra@previsionpersonal.com",
            // password: "123456"
		}
	},
	components:{
        DatepickerBornDate,
        VxCard,
        VxInputGroup,
        FormsRepository  

	},
	created() {
        
        this.sign();
	},
	methods: {
        sign() {
            // const payload = {
            // 	username: this.username,
            // 	password: this.password
            // }

            const payload = {
                token:process.env.VUE_APP_TOKEN_API
            }

		    this.$store.dispatch('auth/loginOauth2', payload)
			.then((response) => {
                if (response.data) {
                    
                    setTimeout(() => this.redirectUrlToSign(), 300);
                   
                }
            })
			.catch( error => {
				 this.$vs.loading.close()
         		 this.$vs.notify({
					title: 'Error',
					text: error.message,
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger'
				})
			})
		},
        redirectUrlToSign(){
             const params = {
                nif: this.dni,
                phone: this.phone,
            }
            this.$http.post(process.env.VUE_APP_BROKER_API + "/authorization-bridge", params)
            .then((response) => {
                
                this.url = response.data;
                //location(this.url)
                //let routeData = this.$router.resolve({name: 'routeName', query: {data: "someData"}});
                window.open(this.url);
                
            })
             .catch( error => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                    title: 'Error',
                    text: error.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            });
        }
	}
}
</script>